import LogActivityReducer from "./activity";
import LogApprovalReducer from "./approval";
import CustomerApprovalReducer from "./customer-approval";
import logPrintReducer from "./print";
import TransactionUpdateReducer from "./transaction-update";

export default {
  logActivity: LogActivityReducer,
  logApproval: LogApprovalReducer,
  customerApproval: CustomerApprovalReducer,
  logPrint: logPrintReducer,
  transactionUpdate: TransactionUpdateReducer,
};
